import * as React from 'react';
import { MessageTypes } from '../core/enums';
import { useMessageStore } from '../zustandStore/messageStore';
import { getApiErrorMessage, isApiError } from '../lib/ApiError';

// TODO 1: may need move this component to app/common after added app context here.
const useAsyncAction = (): ((action: () => Promise<void>) => Promise<void>) => {
	const updateMessage = useMessageStore((state) => state.updateMessage);

	// This fn cannot be called concurrently.
	const performAsyncAction = async (action: () => Promise<void>) => {
		try {
			await action();
		} catch (e) {
			const error = isApiError(e) ? getApiErrorMessage(e) : e.message;
			updateMessage(error, MessageTypes.Error);
		}
	};

	return performAsyncAction;
};

export default useAsyncAction;

// Attribution: https://stackoverflow.com/questions/36862334/get-viewport-window-height-in-reactjs
const getWindowDimensions = () => {
	const { innerWidth: width, innerHeight: height } = window;
	return {
		width,
		height
	};
};

export const useWindowDimensions = () => {
	const [windowDimensions, setWindowDimensions] = React.useState(getWindowDimensions());

	React.useEffect(() => {
		function handleResize() {
			setWindowDimensions(getWindowDimensions());
		}

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return windowDimensions;
};
